import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import axiosInstance from "./services/axiosInstance";

const VisitorIdHandler = () => {
  const [searchParams] = useSearchParams();
  
  useEffect(() => {
    const visitorId = searchParams.get("guid");
    const source = searchParams.get("source");
    
    if (visitorId) {
      Cookies.set("guid", visitorId, { expires: 365 });
      axiosInstance.post(`/EsignServices/create_visitors`, {
        visitor_id: visitorId,
        source: source,
      }, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        console.log("Visitor created successfully:", response.data);
      })
      .catch(error => {
        console.error("Error creating visitor:", error);
      });
    }
  }, [searchParams]);

  return null;
};

export default VisitorIdHandler;
